
export function normalizeValue(value: unknown): unknown {
    
    if (typeof value !== "string") {
        return value;
    }

    if (value === "true" || value === "false") {
        return value === "true";
    }

    if (value.trim() !== "" && !Number.isNaN(Number(value))) {
        return Number(value);
    }

    return value;
}